import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {translate} from 'views/module';

import {DraftTextField, JsonTextField} from '../AgentJobDraftFields';
import {formatJson, getRecipientListDetail, parseJson} from '../../agentJobTypeUtils';

const PushNotificationAgentJobDraft = (props) => {
  const {
    draftPayload,
    paramsJsonText,
    setParamsJsonText,
    updatePayloadField,
  } = props;

  return (
    <Stack sx={{gap: 1.25}}>
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.To')}
        onChange={updatePayloadField('resourceRn')}
        value={draftPayload.resourceRn}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Type')}
        onChange={updatePayloadField('type')}
        value={draftPayload.type}
      />
      <JsonTextField
        label={translate('case.Detail.AgentJobs.Fields.Params')}
        onChange={setParamsJsonText}
        value={paramsJsonText}
      />
    </Stack>
  );
};

PushNotificationAgentJobDraft.propTypes = {
  draftPayload: PropTypes.object.isRequired,
  paramsJsonText: PropTypes.string,
  setParamsJsonText: PropTypes.func.isRequired,
  updatePayloadField: PropTypes.func.isRequired,
};

const buildPayload = ({draftPayload, paramsJsonText}) => ({
  ...draftPayload,
  params: parseJson(paramsJsonText, translate('case.Detail.AgentJobs.Fields.Params')),
});

const getDraftBody = (job) => {
  const payload = job.actionPayload || {};

  if (payload.type === 'NEW_JOB_POSTING') {
    return [
      payload.params?.jobTitle,
      payload.params?.weeklyPay ?
        translate('case.Detail.AgentJobs.WeeklyPay', {amount: payload.params.weeklyPay}) :
        '',
      payload.params?.jobRn,
    ].filter(Boolean).join('\n');
  }

  return formatJson(payload.params || {});
};

const getDraftSubtitle = (job) => job.actionPayload?.type || translate('case.Detail.AgentJobs.ActionLabels.PushNotification');

const getListDetail = (job, participantDetails) => {
  const payload = job.actionPayload || {};

  return [
    getRecipientListDetail(participantDetails, payload.resourceRn || job.resourceRn),
    payload.type,
  ].filter(Boolean).join(' - ');
};

export default {
  Draft: React.memo(PushNotificationAgentJobDraft),
  actionType: 'PUSH_NOTIFICATION',
  buildPayload,
  getDraftBody,
  getDraftSubtitle,
  getListDetail,
  label: translate('case.Detail.AgentJobs.ActionLabels.PushNotification'),
};
